module.exports = __webpack_public_path__ + "img/18.95324e49.jpg";